import { faSpinner } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useTranslation } from "react-i18next"

import { formatNumber } from "../../utilities/format"
import { useOnlineStatus } from "../../components/Hooks/useOnlineStatus"

type GeologyCrushingTableFooterProps = {
  totalLoads?: number
  totalTonnes?: number
  isLoading: boolean
}

const GeologyCrushingTableFooter: React.FC<GeologyCrushingTableFooterProps> = ({
  totalLoads,
  totalTonnes,
  isLoading
}) => {
  const { t } = useTranslation("geology");
  const isOnline = useOnlineStatus();
  const tonnesDisplay = !isOnline && !totalTonnes
    ? t("totals.tbc")
    : totalTonnes != null ? formatNumber(Math.round(totalTonnes)) : '';
  return (
    <div className="flex justify-end md:items-center flex-col md:flex-row gap-2 bg-theme-surface-2 border border-theme-table-border border-t-2 border-t-theme-table-border p-2 mb-4 fade-up shadow">
      <div className="flex items-center justify-end">
        <span className="p-4 text-2xl text-theme-text translate-y-1 transition ease-out">{t("totals.loads")}</span>
        <span className="p-3 w-24 flex justify-center items-center font-bold bg-theme-warning rounded relative">
          <FontAwesomeIcon icon={faSpinner} spin
            className={`text-5xl text-theme-text transition ease-out opacity-${isLoading ? 100 : 0}`} />
          <span
            className={`text-4xl absolute top-1/2 transform -translate-y-[50%] transition ease-out opacity-${isLoading ? '0' : '100'}`}>
            {formatNumber(totalLoads)}
          </span>
        </span>
      </div>
      <div className="flex items-center justify-end">
        <span className="p-4 text-2xl text-theme-text translate-y-1 transition ease-out">{t("totals.tonnes")}</span>
        <span className="p-3 flex min-w-36 justify-center items-center font-bold bg-theme-warning rounded relative">
          <FontAwesomeIcon icon={faSpinner} spin
            className={`text-5xl text-theme-text transition ease-out opacity-${isLoading ? 100 : 0}`} />
          <span
            className={`text-4xl  absolute top-1/2 transform -translate-y-[50%] transition ease-out opacity-${isLoading ? '0' : '100'}`}>
            {tonnesDisplay}
          </span>
        </span>
      </div>
    </div>
  )
}

export default GeologyCrushingTableFooter